module.exports = __webpack_public_path__ + "static/media/comment1.f90bb954.png";